import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const getAllCompanyAppointments = (id, workerId = "All", status = "All") => {
  return Api(
    `${endPoints.getAppointmentsByCompanyId}/${id}?workerId=${workerId}&status=${status}`,
    null,
    requestType.GET
  );
};

const updateAppointmentStatus = (id, params) => {
  return Api(
    `${endPoints.updateAppointmentStatus}/${id}`,
    params,
    requestType.PUT
  );
};
const updateAppointmentWorkerStatus = (id, params) => {
  console.log(id, params, "paramsparamsparamsparams");
  return Api(
    `${endPoints.updateAppointmentWorkerStatus}/${id}`,
    params,
    requestType.PUT
  );
};

const getCompanyUpcommingJobs = (id) => {
  return Api(`${endPoints.getCompanycommingJobs}/${id}`, null, requestType.GET);
};

export {
  getAllCompanyAppointments,
  updateAppointmentStatus,
  updateAppointmentWorkerStatus,
  getCompanyUpcommingJobs,
};
